import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderShield"><Path d="M12.5 19.5H2.5V3.5H10L12 6.5H21.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19 12L15.5 13.5V16.3624C15.5 17.9625 16.4536 19.4087 17.9243 20.039L19 20.5L20.0757 20.039C21.5464 19.4087 22.5 17.9625 22.5 16.3624V13.5L19 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFolderShield;
